export default __webpack_public_path__ + "static/media/9296.2ffd8850.svg";